export class HtmlBuilder {
	constructor(ids, classes, content) {
		this.ids = ids
		this.classes = classes
		this.content = content
	}

	build() {
		return this.buildGallery()
	}

	buildGallery() {
    if (this.content.type === 'grid') {
      return this.buildGrid()
    } else if (this.content.type === 'slider') {
      return this.buildSlider()
    } else {
      return this.buildMasonry()
    }
  }

	buildGrid() {
    const images = this.content.images
    const elementClasses = this.classes

    if (images.length) {
      let imagesHtml = '';
      images.forEach(function (img) {
        imagesHtml += `<div
          class="wf-w-full sm:wf-w-1/2 md:wf-w-1/3 lg:wf-w-1/5 ${elementClasses.classes}"
        ><img src="${img.url}" alt="${img.alt}" class="${elementClasses.contentClasses}" /></div>`;
      })
      return `<div class="${elementClasses.itemClasses}">${imagesHtml}</div>`
    }
    return ''
  }

  buildMasonry() {
    const images = this.content.images
    const elementClasses = this.classes

    if (images.length) {
      let imagesHtml = '';
      images.forEach(function (img) {
        imagesHtml += `\n<div class="wf-w-1/4 lg:wf-w-1/4 wf-p-1">`
          + `<img src="${img.url}" alt="${img.alt}" class="${elementClasses.contentClasses}" />`
          + `</div>`
      })
      return `<div class="${elementClasses.itemClasses}">${imagesHtml}</div>`
    }
    return ''
  }

  buildSlider() {
    const images = this.content.images
    const elementClasses = this.classes

    if (images.length) {
      let imagesHtml = '';
      images.forEach(function (img) {
        imagesHtml += `\n<div class="wf-w-1/4 lg:wf-w-1/4 wf-p-1">`
          + `<img src="${img.url}" alt="${img.alt}" class="${elementClasses.contentClasses}" />`
          + `</div>`
      })
      return `<div>${imagesHtml}</div>`
    }

    return ''
  }
}
